import styled from "styled-components"

import {Para} from "@irati/ui/src/Labels"
import Link from "@irati/ui/src/Link"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {greys} from "@irati/ui/src/global/colors"

interface WrapperProps {
  isMarginLarge?: boolean
}

interface GreyProps {
  isGrey?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  margin-top: ${({isMarginLarge}) => (isMarginLarge ? "60px" : "20px")};
`

export const StyledLink = styled(Link)<GreyProps>`
  ${({isGrey}) => isGrey && `color: ${greys.medium};`}
  display: inline-block;
  font-size: 12px;
  ${minWidthMedia.tablet`
    font-size: 14px;
  `}
`

export const InlinePara = styled(Para)<GreyProps>`
  ${({isGrey}) => isGrey && `color: ${greys.medium};`}
  display: inline;
`
